import { useState } from "react";
import { useSelector } from "react-redux";

import { OpenInNew } from "@livechat/design-system-icons";
import { Button, Icon, ModalPortal, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { selectHasLiveChatIntegration } from "store/entities/integrations";
import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

import { DataImportModal } from "./DataImportModal";
import { EXTERNAL_DATA_IMPORT_URL } from "./constants";

export const DataImportButton: React.FC = () => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const hasLiveChat = useSelector(selectHasLiveChatIntegration);

  const handleOpenModal = (): void => setIsImportModalOpen(true);

  const handleImportData = (): void => {
    trackEngagement("Settings: Migration link clicked", EventPlace.Settings, {
      modalOpened: hasLiveChat,
    });

    if (hasLiveChat) {
      handleOpenModal();
    }
  };

  return (
    <Flex padding={withVar(SpacingToken.Spacing6)}>
      <Button
        kind="link-light"
        onClick={handleImportData}
        href={hasLiveChat ? undefined : EXTERNAL_DATA_IMPORT_URL}
        target={hasLiveChat ? undefined : "_blank"}
        icon={hasLiveChat ? undefined : <Icon source={OpenInNew} size="small" />}
        iconPosition="right"
        data-testid="import-data-button"
      >
        Import data to HelpDesk
      </Button>
      <ModalPortal zIndex={StackingContextLevel.Modal}>
        {isImportModalOpen && <DataImportModal onClose={() => setIsImportModalOpen(false)} />}
      </ModalPortal>
    </Flex>
  );
};
